/**
 * pull human-readable strings from ShipNext-style API error bodies
 * upports errors[].message (assertions / controller errors) and errors[].messages[0] (validators)
 *
 * @param {*} data - parsed JSON from error response body
 * @returns {string[]}
 */
export function apiErrorMessagesFromBody(data) {
    if (!data || typeof data !== 'object') {
        return [];
    }
    const topMessage = typeof data.message === 'string' ? data.message.trim() : '';
    const { errors } = data;
    if (!Array.isArray(errors) || errors.length === 0) {
        return topMessage ? [topMessage] : [];
    }

    const out = [];
    for (let i = 0; i < errors.length; i += 1) {
        const errItem = errors[i];
        if (errItem && typeof errItem === 'object') {
            let msg =
                typeof errItem.message === 'string' ? errItem.message.trim() : '';

            if (!msg && Array.isArray(errItem.messages)) {
                const m0 = errItem.messages[0];
                if (typeof m0 === 'string') {
                    msg = m0.trim();
                } else if (m0 && typeof m0 === 'object' && typeof m0.message === 'string') {
                    msg = m0.message.trim();
                }
            }

            if (msg) {
                out.push(msg);
            }
        }
    }

    if (out.length > 0) {
        const seen = new Set();
        return out.filter((m) => {
            if (seen.has(m)) return false;
            seen.add(m);
            return true;
        });
    }

    return topMessage ? [topMessage] : [];
}

/**
 * @param {unknown} error - axios rejection
 * @param {string} fallback
 * @returns {string}
 */
export function messageFromAxiosError(error, fallback) {
    if (!error || typeof error !== 'object') {
        return fallback;
    }
    const ax = /** @type {{ response?: { data?: unknown }; message?: string }} */ (error);
    const resp = ax.response;
    const fromBody = resp && resp.data !== undefined ? apiErrorMessagesFromBody(resp.data) : [];
    if (fromBody.length > 0) {
        return fromBody.join(' ');
    }
    if (typeof ax.message === 'string' && ax.message) {
        return ax.message;
    }
    return fallback;
}



// WEBPACK FOOTER //
// ./app/services/utils/response.js